import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["text", "campaignColor", "truncate"];
import { Flex } from 'foundations-components/components/Flex';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function CampaignOptionLabel(_ref) {
  let {
      text = '',
      campaignColor,
      truncate
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsxs(Flex, Object.assign({}, rest, {
    "data-test-id": `select-dropdown-option-${text}`,
    alignItems: "center",
    gap: '200',
    children: [campaignColor && /*#__PURE__*/_jsx("div", {
      style: {
        backgroundColor: campaignColor,
        width: 8,
        height: 8,
        borderRadius: '50%',
        flexShrink: 0
      }
    }), truncate ? /*#__PURE__*/_jsx(TruncateString, {
      maxWidth: 300,
      children: text
    }) : text]
  }));
}